import { Component, Input } from "@angular/core";
import { PartyLookupDTO } from "../../../../services/swagger-gen/fordesk";

@Component({
  selector: "party-address-label",
  templateUrl: "./party-address-label.html"
})
// tslint:disable-next-line: component-class-suffix
export class PartyAddressLabel {
  @Input()
  public item: PartyLookupDTO;

  constructor() { }
}
